// extracted by mini-css-extract-plugin
module.exports = {"active":"TabsComponents_active__2tfdS"};